/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { date, DateFormat, entity, enumeration } from '@gh/core-data';
import {
  JobDppCreateRequestDto,
  SalesFolderDto,
  SalesFolderRfqGeneralDto,
  SalesFolderShortDto,
  SalesFolderStatus,
} from './sales-folder.dto';

export const SalesFolderCompleteMapper = entity<SalesFolderDto>({
  created: date(DateFormat.DateTime),
  followUp: date(DateFormat.DateTime),
  status: enumeration(SalesFolderStatus),
});

export const SalesFolderRfqGeneralMapper = entity<SalesFolderRfqGeneralDto>({
  status: enumeration(SalesFolderStatus),
});

export const SalesFolderShortMapper = entity<SalesFolderShortDto>({
  created: date(DateFormat.DateTime),
});

export const JobDppCreateRequestMapper = entity<JobDppCreateRequestDto>({});
